import { Typography } from '@mui/material';
import React from 'react';
import Image from '@/components/shared/Image';

type Props = {
    text: string;
    nameAndFunction: string;
    stars: number;
    className?: string;
}

const ReviewNew = ({ text, nameAndFunction, stars, className = '' }: Props) => {
    return (
        <div className={`p-4 bg-real-white/30 border border-[#E5E7EB] rounded-lg ${className}`}>
            <Typography variant='body1' className='text-primary-gray-950'>
                {text}
            </Typography>
            
            <Typography variant='h5' component='h2' className='text-primary-gray-950 font-bold capitalize mt-6'>
                {nameAndFunction}
            </Typography>

            <div className="flex items-center gap-x-1">
                {Array.from({ length: stars }).map((_, index) => (
                    <Image
                        key={index}
                        src='Icons/star_utfvhs'
                        alt='Star'
                        width={20}
                        height={20}
                    />
                ))}
            </div>
        </div>
    );
}

export default ReviewNew;